'use client'
import { useTranslation } from 'next-i18next'

import { PartnerProductCard } from '@src/quince-components/src'
import Swiper from '@src/quince-components/src/atoms/swiper'
import { DOTS_POSITION, NAV_POSITION } from '@src/quince-components/src/atoms/swiper/Swiper'
import PartnerProduct from '@src/quince-site-common/src/domains/PartnerProduct'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import makeChunks from '@src/quince-site-common/src/utils/makeChunks'
import { SectionProps } from '@src/SectionRenderer/SectionRenderer.types'

import styles from './recommendedProductList.module.scss'

const RecommendedProductList = (props: SectionProps) => {
  const { partnerProduct } = props.sectionConfig
  const deviceInfo = useDeviceInfo()
  const { t } = useTranslation('landing')
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP

  if ((partnerProduct?.recommendedPartnerProduct || []).length === 0) return null
  const recommendedPartnerProductChunks = makeChunks(partnerProduct?.recommendedPartnerProduct, 4)
  return (
    <div className={styles.recommendedProductListContainer}>
      <h1 className={styles.recommendedProductListContainer__title}>{t('more_ways_to_earn_credit')}</h1>
      {
        <Swiper
          id="recommended-product-list"
          numberOfVisibleSlides={isDesktop ? 4 : 1}
          showDots={!isDesktop}
          variableWidth
          showNavigator={isDesktop}
          dotsPosition={DOTS_POSITION.BOTTOM}
          navPosition={NAV_POSITION.RIGHT_WITH_PADDING}
          withChildWrapper
        >
          {isDesktop
            ? (partnerProduct?.recommendedPartnerProduct || []).map((card: PartnerProduct) => {
                return (
                  <PartnerProductCard
                    className={styles.recommendedProductListContainer__productList}
                    imageClassName={styles.productCardImage}
                    key={card.contentfulPartnerProductId}
                    product={card}
                  />
                )
              })
            : recommendedPartnerProductChunks.map((chunk, i) => {
                return (
                  <div className={styles.recommendedProductListContainer__productCardWrapperMobile} key={i}>
                    {chunk.map(c => (
                      <PartnerProductCard
                        className={styles.productList}
                        imageClassName={styles.productCardImage}
                        key={c.contentfulPartnerProductId}
                        product={c}
                      />
                    ))}
                  </div>
                )
              })}
        </Swiper>
      }
    </div>
  )
}

export default RecommendedProductList
